import React, { useState } from 'react';
import { ArrowIconClickToOpen } from '@images/svg/index';
import {
  StyledDetailsCover,
  StyledMainHeadline,
  StyledTitleWrapper,
  StyledTitle,
  StyledIconWrapper,
  StyledDescription,
  StyledSepratorGray
} from './styles';

const FAQQUESTIONEXPAND = ({
  data, heading, treatment, homePage
}) => {
  const [displayDescription, setDisplayDescription] = useState(null);
  return (
    <StyledDetailsCover homePage={homePage}>
      {!homePage
      && (
        <>
          <StyledMainHeadline treatment={treatment}>{heading}</StyledMainHeadline>
          <StyledSepratorGray />
        </>
      )}
      {data.map((faq, idx) => (
        <div key={faq.id}>
          <StyledTitleWrapper
            key={faq.id}
            onClick={() => {
              setDisplayDescription(faq.id === displayDescription ? false : faq.id);
            }}
          >
            <StyledTitle treatment={treatment}>{faq.attributes.question}</StyledTitle>
            <StyledIconWrapper active={faq.id === displayDescription}>
              <ArrowIconClickToOpen />
            </StyledIconWrapper>
          </StyledTitleWrapper>
          <StyledDescription active={faq.id === displayDescription}>
            <div dangerouslySetInnerHTML={{ __html: faq.attributes.answer }} />
          </StyledDescription>

          <StyledSepratorGray islast={idx === data.length - 1} />
        </div>
      ))}
    </StyledDetailsCover>
  );
};
export default FAQQUESTIONEXPAND;
